import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import ArticleIcon from "@mui/icons-material/Article";
import PersonIcon from "@mui/icons-material/Person";
import MapIcon from "@mui/icons-material/Map";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import HttpIcon from "@mui/icons-material/Http";
import HistoryIcon from "@mui/icons-material/History";
import ReceiptIcon from "@mui/icons-material/Receipt";
import DescriptionIcon from "@mui/icons-material/Description";
import { getPrecioUnidad } from "./handlers";
import { renderModal } from "../handlers";
import FormCambiarPrecioUnidad from "../Articulos/FormCambiarPrecioUnidad";
import { UserContext } from "../../context/UserWrapper";
import { logout } from "../../utils/sessionStorage";
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner";
import MenuButton from "../../components/MenuButton";
import MuniSpinner from "../../components/MuniSpinner";

const Home = () => {
  const [precioUnidad, setPrecioUnidad] = useState(null);
  const [precioUnidadIsLoading, setPrecioUnidadIsLoading] = useState(true);
  const [cambiarPrecioUnidadModalIsOpen, setCambiarPrecioUnidadModalIsOpenIsOpen] = useState(false);
  const { actions: ua } = useContext(UserContext);

  useEffect(() => {
    if (
      !ua.hasPermission(
        "app.access"
      ) /*  && !ua.hasPermission('usuarios.view') && !ua.hasPermission('articulos.view') */
    ) {
      logout();
    }
    if (ua.hasPermission("precioUnidad.edit")) {
      getPrecioUnidad(setPrecioUnidad, setPrecioUnidadIsLoading);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className='px-2'>
        <h2>Pago Voluntario {ua.hasPermission("app.access") && " - Admin"}</h2>
        <hr className='mt-0' />
        <div className='mt-2 d-flex flex-wrap gap-2 align-items-center'>
          {ua.hasPermission("actas.view") && (
            <MenuButton to='/actas' icon={<ReceiptLongIcon className='me-2' />}>
              Actas
            </MenuButton>
          )}
          {ua.hasPermission("articulos.view") && (
            <MenuButton to='/articulos' icon={<ArticleIcon className='me-2' />}>
              Articulos
            </MenuButton>
          )}
          {ua.hasPermission("usuarios.view") && (
            <MenuButton to='/usuarios' icon={<PersonIcon className='me-2' />}>
              Usuarios
            </MenuButton>
          )}
          {ua.hasRole("sudo") && (
            <MenuButton to='/mapa-de-calor' icon={<MapIcon className='me-2' />}>
              Mapa de Calor
            </MenuButton>
          )}
          {ua.hasPermission("recibosPagos.view") && (
            <MenuButton to='/recibos' icon={<ReceiptIcon className='me-2' />}>
              Recibos Pagos
            </MenuButton>
          )}
          {ua.hasRole("sudo") && (
            <MenuButton to='/historial-inspectores' icon={<HistoryIcon className='me-2' />}>
              Historial Inspectores
            </MenuButton>
          )}
          {ua.hasRole("sudo") && (
            <MenuButton to='/endpoints-tablero' icon={<HttpIcon className='me-2' />}>
              Endpoints Tablero
            </MenuButton>
          )}
          {ua.hasRole("sudo") && (
            <MenuButton to='/listado-de-actas-vencidas' icon={<DescriptionIcon className='me-2' />}>
              Listado de Actas Vencidas
            </MenuButton>
          )}
        </div>
        <hr />
        <div className='mb-2 align-items-center gap-4'>
          {ua.hasPermission("precioUnidad.edit") && precioUnidadIsLoading && (
            <div className='d-flex'>
              <MuniSpinner />
            </div>
          )}
          {ua.hasPermission("precioUnidad.edit") && precioUnidad ? (
            <>
              <h4>Precio Unidad: ${precioUnidad && precioUnidad}</h4>
              <Button onClick={() => setCambiarPrecioUnidadModalIsOpenIsOpen(true)}>Cambiar Precio Unidad</Button>
              {renderModal(
                cambiarPrecioUnidadModalIsOpen,
                setCambiarPrecioUnidadModalIsOpenIsOpen,
                "Cambiar Precio Unidad",
                <>
                  <h5>Precio actual: ${precioUnidad}</h5>
                  <FormCambiarPrecioUnidad
                    setPrecioUnidad={setPrecioUnidad}
                    setCambiarPrecioUnidadModalIsOpenIsOpen={setCambiarPrecioUnidadModalIsOpenIsOpen}
                  />
                </>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Home;
